import { render } from "./ParentViewerDialog.vue?vue&type=template&id=6b20c238&scoped=true"
import script from "./ParentViewerDialog.vue?vue&type=script&lang=ts"
export * from "./ParentViewerDialog.vue?vue&type=script&lang=ts"

import "./ParentViewerDialog.vue?vue&type=style&index=0&id=6b20c238&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6b20c238"

export default script